export const APP_ID = "drawstring-acpul";
